import React from 'react'

export default function SectionHead({img1,img2,text}) {
  return (
    <span className="headText my-2">
          {img1?<><img src={img1} alt="butterfly" className="butterfly butterfly7"/></>:<></>}
          {img1?<><img src={img1} alt="butterfly" style={{ width: '50px', height: '50px' }} /></>:<></>}
            
            {text}
            {img2?<><img src={img2} alt="butterfly" className="butterfly butterfly8"/></>:<></>}
            {img2?<><img src={img2} alt="butterfly" style={{ width: '50px', height: '50px' }} /></>:<></>}
            </span>
  )
}
